<script>

	import { onMount } from 'svelte';
	import { fly } from "svelte/transition";

	import moment from 'moment-timezone';

	import Session from './Now/Session.svelte';
	import Location from './Now/Location.svelte';

	import Button from "./ui/Button.svelte";

	import { agenda, session, epoch, spotlight } from "./lib/stores.js";
	import {	showDate } from './lib/dt.js';

	let mounted = false;
	let appSessions = [];
	let sorted;

	onMount(() => {

		for (const s of $agenda.sessions) {
			if (s.app && s.app.useApp) {

				s.locations = [];

				for (const st of $agenda.sessionTypes) {
					if (s.sessionType == st.ref) {
						for (const c of st.components) {
							if (c.component == 'Location') {
								if (s.details[c.ref]) {
									s.locations.push(s.details[c.ref]);
								}
							}
						}
					}
				}

				// console.log({s});

				appSessions.push(s);

			}
		}
		
		sorted = appSessions.sort(function(a,b){
			return moment(a.starts).diff(moment(b.starts));
		});

		mounted = true;

	});

</script>

<style>
	.panel {
		max-width: 90vw;
		width: 700px;
		box-sizing: border-box;
		position: relative;
		border-radius: 4px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 0.3rem 1rem;
		font-size: 1rem;
		line-height: 1.4;
		max-height: 70vh;
		overflow: scroll;
	}
	.session {
		margin: 0.8rem 0;
		display: flex;
		gap: 1rem;
		justify-content: space-between;
		align-items: center;
		background: var(--blend-10);
		color: var(--textColor);
		padding: 0.5rem 0.8rem;
		border-radius: 4px;
		/*box-shadow: 0 4px 10px var(--shadow);*/
		/*transition: transform 0.2s ease;*/
	}
	/*.session:hover {
		transform: scale(1.02);
	}*/
	.session p {
		text-align: left;
	}
	.session.past {
		opacity: 0.5;
	}
	/*.session.past:hover {
		transform: scale(1);
	}*/
	.date {
		font-size: 0.6875rem;
		color: var(--blend-80);
		margin-top: 0.2rem;
	}
</style>

{#if mounted}
	{#if $session}
		{#key $session.ref}
			<Session/>
		{/key}
	{:else}
		<div class="panel" in:fly={{ duration: 400, y: 20 }}>
			{#each sorted as s}
				<div class="session" class:past={$epoch > s.epochEnds}>
					<div>
						<p><strong>{s.name}</strong></p>
						<p class="date">{showDate(s.starts, 'dddd DD MMM, HH:mm')}–{showDate(s.ends, 'HH:mm')}</p>
						{#each s.locations as l}
							<Location details={l}/>
						{/each}
					</div>
					{#if $epoch <= s.epochEnds}
						<div class="join">
							<Button on:click={() => { $session = s; $spotlight = null; }} label="Join session" mini={true}/>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	{/if}
{/if}